import { useState } from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'primereact/checkbox'

import { useInit } from './common'
import { WidgetContainer } from './StyledComps'
import { ToastifyLabel } from './ToastifyLabel'

export function SingleCheck({
  fieldname,
  label,
  value,
  onCheck,
  onDirty,
  labelAttributes = { width: '150px' },
  inputAttributes = { width: '100%' },
}) {
  const [, compare] = useInit(value)
  const [checked, setChecked] = useState(value)

  return (
    <WidgetContainer
      width={inputAttributes.width}
      data-cy={`SingleCheck-${fieldname}`}
    >
      <ToastifyLabel
        changed={compare(checked)}
        fieldname={fieldname}
        label={label}
        {...labelAttributes}
      />
      <Checkbox
        checked={checked}
        onChange={({ checked }) => {
          setChecked(checked)
          onCheck(fieldname, checked)
          onDirty(fieldname, compare(checked))
        }}
      />
    </WidgetContainer>
  )
}

SingleCheck.propTypes = {
  fieldname: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onCheck: PropTypes.func.isRequired,
  onDirty: PropTypes.func.isRequired,
  width: PropTypes.string,
  labelAttributes: PropTypes.object,
  inputAttributes: PropTypes.object,
}
